<div *ngIf="paymentWarnings?.length" class="mb-3 mt-3">
  <app-show-warnings [warnings]="paymentWarnings"></app-show-warnings>
</div>

<div class="mt-3">
  <error-alert-block
    [error]="paymentError"
  ></error-alert-block>
</div>

<div *ngIf="step == 'payment'"
     [formGroup]="service.form"
     class="sentry-mask mt-4 needs-validation payment-form">
   <div *ngIf="showTotalPrice"
        class="payment-info__price"
        [class.payment-info__price_primary]="totalPrice > 0"
        [class.payment-info__price_danger]="totalPrice < 0"
   >
     <div class="mt-4 changed-price total-amount">
       <span>To be paid:</span> <b>{{totalPrice | number :'1.2-2' }}</b> {{currency}}
     </div>
 </div>
  <div class="form-row" *ngIf="paymentMethodsExists">
    <div class="payment-type col-md-auto"
         [class.form-group-xl]="!(warningsPerPaymentMethod.card.length && isCardMethod)"
         *ngIf="settings">
      <div class='pt-4'><h3>{{ 'PAYMENT_FORM_MODAL.PAYMENT_METHOD' | translate }}</h3></div>
      <div
        *ngIf="settings.none"
        class="form-check form-check-inline"
      >
        <input class="form-check-input" id="r1" type="radio" value="none" formControlName="method"
               [validate]="validateTriggered" (change)="onPaymentMethodChange($event.target.value)">
        <label class="form-check-label" for="r1">
          {{ 'PAYMENT_FORM_MODAL.FORM.METHODS.NONE' | translate }}
        </label>
      </div>
      <div
        *ngIf="settings.agencyCash"
        class="form-check form-check-inline"
      >
        <input class="form-check-input" id="r4" type="radio" value="agencyCash" formControlName="method"
              [validate]="validateTriggered" (change)="onPaymentMethodChange($event.target.value)">
        <label class="form-check-label" for="r4">
          {{ 'PAYMENT_FORM_MODAL.FORM.METHODS.AGENCY_CASH' | translate }}
        </label>
      </div>
      <div
        *ngIf="settings.agencyCard"
        class="form-check form-check-inline"
      >
        <input class="form-check-input" id="r2" type="radio" value="agencyCard" formControlName="method"
               [validate]="validateTriggered" (change)="onPaymentMethodChange($event.target.value)">
        <label class="form-check-label" for="r2">
          {{ 'PAYMENT_FORM_MODAL.FORM.METHODS.AGENCY_CARD' | translate }}
        </label>
      </div>
      <div
        *ngIf="settings.card"
        class="form-check form-check-inline"
      >
        <input class="form-check-input" id="r3" type="radio" value="card" formControlName="method"
               [validate]="validateTriggered" (change)="onPaymentMethodChange($event.target.value)">
        <label class="form-check-label" for="r3">
          {{ 'PAYMENT_FORM_MODAL.FORM.METHODS.CREDIT_DEBIT_CARD' | translate }}
        </label>
      </div>
      <div
        *ngIf="settings.easyPay"
        class="form-check form-check-inline"
      >
        <input class="form-check-input" id="r5" type="radio" value="easyPay" formControlName="method"
               [validate]="validateTriggered" (change)="onPaymentMethodChange($event.target.value)">
        <label class="form-check-label" for="r5">
          {{ 'PAYMENT_FORM_MODAL.FORM.METHODS.EASYPAY' | translate }}
        </label>
      </div>
      <div
      *ngIf="settings.uatp"
      class="form-check form-check-inline"
    >
      <input class="form-check-input" id="r6" type="radio" value="uatp" formControlName="method"
             [validate]="validateTriggered" (change)="onPaymentMethodChange($event.target.value)">
      <label class="form-check-label" for="r6">
        {{ 'PAYMENT_FORM_MODAL.FORM.METHODS.UATP' | translate }}
      </label>
    </div>
    </div>
    <ng-container *ngIf="warningsPerPaymentMethod.card.length && isCardMethod">
      <div class="alert alert-warning p-3 my-4 rounded"
           *ngFor="let cardWarning of warningsPerPaymentMethod.card">
        {{cardWarning}}
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="!hasCustomPayment">
    <div class="form-row">
      <div class="form-group col-md-12">
        <ng-container *ngIf="!paymentMethodsExists">
          {{ 'PAYMENT_FORM_MODAL.NO_PAYMENT_OPTIONS' | translate }}
        </ng-container>
        <ng-container *ngIf="service.form.get('method').value === 'agencyCard'">
          {{ 'PAYMENT_FORM_MODAL.SELECTED_METHOD' | translate }} <b>{{ 'PAYMENT_FORM_MODAL.FORM.METHODS.AGENCY_CARD' | translate }}</b>.
        </ng-container>
        <ng-container *ngIf="service.form.get('method').value === 'agencyCash'">
          {{ 'PAYMENT_FORM_MODAL.SELECTED_METHOD' | translate }} <b>{{ 'PAYMENT_FORM_MODAL.FORM.METHODS.AGENCY_CASH' | translate }}</b>.
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container [ngTemplateOutlet]="cardForm"></ng-container>
</div>

<ng-template #cardForm>
  <ng-container [formGroup]="service.form">
    <ng-container *ngIf="hasCustomPayment">
      <h4>{{ 'PAYMENT_FORM_MODAL.FORM.CARD.LABEL' | translate }}</h4>
      <div class="form-row"
           *ngIf="isCardMethod">
        <div class="form-group-sm"
             [ngClass]="showSurchargeType ? 'col-md-3' : 'col-md-4'">
          <div class="col p-0">
            <label>
              {{ 'PAYMENT_FORM_MODAL.FORM.CARD.CARD_TYPE.LABEL' | translate }}
              <span class="text-primary"><b>*</b></span>
            </label>
            <select [validate]="service.form.get('cardType').dirty || validateTriggered"
                    formControlName="cardType"
                    class="form-control">
              <option value="CC">{{ 'PAYMENT_FORM_MODAL.FORM.CARD.CARD_TYPE.OPTIONS.CREDIT' | translate }}</option>
              <option value="DB">{{ 'PAYMENT_FORM_MODAL.FORM.CARD.CARD_TYPE.OPTIONS.DEBIT' | translate }}</option>
            </select>
          </div>
        </div>
        <div [ngClass]="showSurchargeType ? 'col-md-9' : 'col-md-8'">
          <div class="form-row">
            <div class="form-group-sm"
                 [ngClass]="showSurchargeType ? 'col-md-4' : 'col-md-6'">
              <label>
                {{ 'PAYMENT_FORM_MODAL.FORM.CARD.CARD_CODE.LABEL' | translate }}
                <span class="text-primary"><b>*</b></span>
              </label>
              <select [validate]="service.form.get('cardCode').dirty || validateTriggered"
                      formControlName="cardCode"
                      class="form-control"
                      (change)="setCardType($event)">
                <option *ngFor="let code of modifiedCardCodes | keyvalue" [value]="code.key">
                  {{ code.value }}
                </option>
              </select>
            </div>
            <ng-container *ngIf='showSurchargeType'>
              <div class="form-group-sm col-md-8"
                   *ngIf="service.form.get('surchargeType') as surchargeType">
                <label>
                  {{ 'PAYMENT_FORM_MODAL.FORM.CARD.SURCHARGE_TYPE.LABEL' | translate }}
                  <span class="text-primary"><b>*</b></span>
                </label>
                <div class="d-flex align-items-center">
                  <select [validate]="surchargeType.dirty || validateTriggered"
                          formControlName="surchargeType"
                          class="form-control"
                          (change)="setSurchargeType($event)">
                    <option hidden selected value="">{{ 'PAYMENT_FORM_MODAL.FORM.CARD.SURCHARGE_TYPE.OPTIONS.EMPTY' | translate }}</option>
                    <option *ngFor="let surchargeType of surchargeTypes" [value]="surchargeType">{{surchargeType}}
                  </select>
                  <span *ngIf="surchargesInfo" class="surcharges-info">+{{surchargesInfo}}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group-sm col-md-4">
          <label>
            {{ 'PAYMENT_FORM_MODAL.FORM.CARD.CARD_NUMBER.LABEL' | translate }}
            <span class="text-primary"><b>*</b></span>
          </label>
          <input [validate]="service.form.get('cardNumber').dirty || validateTriggered"
                 type="text"
                 formControlName="cardNumber"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.CARD.CARD_NUMBER.PLACEHOLDER' | translate"
                 class="form-control"/>
        </div>

        <div class="col-md-5" *ngIf="isCardMethod">
          <div class="form-row">
            <div class="form-group-sm col-md-6" *ngIf="service.form.get('seriesCode') as seriesCode">
              <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARD.SERIES_CODE.LABEL' | translate }}</label>
              <div class="form-row">
                <div class="col-md-8">
                  <input [validate]="seriesCode.dirty || validateTriggered"
                         type="text"
                         formControlName="seriesCode"
                         class="form-control"
                         [placeholder]="'PAYMENT_FORM_MODAL.FORM.CARD.SERIES_CODE.PLACEHOLDER' | translate"
                  />
                </div>
              </div>
            </div>
            <div class="form-group-sm col-md-6" *ngIf="service.form.get('approvalCode') as approvalCode">
              <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARD.APPROVAL_CODE.LABEL' | translate }}</label>
              <div class="form-row">
                <div class="col-md-8">
                  <input [validate]="approvalCode.dirty || validateTriggered"
                         type="text"
                         formControlName="approvalCode"
                         class="form-control"
                         [placeholder]="'PAYMENT_FORM_MODAL.FORM.CARD.APPROVAL_CODE.PLACEHOLDER' | translate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 form-group-sm" *ngIf="!isCardMethod">
          <ng-container [ngTemplateOutlet]="expirationDateControls"></ng-container>
        </div>
      </div>

      <div class="form-row" *ngIf="isCardMethod">
        <div class="col-md-4 form-group-xl">
          <ng-container [ngTemplateOutlet]="expirationDateControls"></ng-container>
        </div>
      </div>

      <h4>{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.LABEL' | translate }}</h4>
      <div class="form-row">
        <div class="form-group-sm col-md-2">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.TITLE.LABEL' | translate }}</label>
          <select [validate]="service.form.get('cardHolderTitle').dirty || validateTriggered"
                  class="form-control"
                  name="cardHolderTitle"
                  id="cardHolderTitle"
                  formControlName="cardHolderTitle">
            <option value="MR">{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.TITLE.OPTIONS.MR' | translate }}</option>
            <option value="MS">{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.TITLE.OPTIONS.MS' | translate }}</option>
          </select>
        </div>

        <div class="form-group-sm col-md-5">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.NAME.LABEL' | translate }}</label>
          <input [validate]="service.form.get('cardHolderName').dirty || validateTriggered"
                 type="text"
                 formControlName="cardHolderName"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.NAME.PLACEHOLDER' | translate"/>
        </div>
        <div class="form-group-sm col-md-5">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.SURNAME.LABEL' | translate }}</label>
          <input [validate]="service.form.get('cardHolderSurname').dirty || validateTriggered"
                 type="text"
                 formControlName="cardHolderSurname"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.SURNAME.PLACEHOLDER' | translate"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group-sm col-md-6">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.EMAIL.LABEL' | translate }}</label>
          <input [validate]="service.form.get('cardHolderEmail').dirty || validateTriggered"
                 type="text"
                 formControlName="cardHolderEmail"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.EMAIL.PLACEHOLDER' | translate"/>
        </div>

        <div class="form-group-xl col-md-6"
             formGroupName="phone"
             *ngIf="service.form.get('phone.number') as phoneNumber">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.CARDHOLDER.PHONE.LABEL' | translate }}</label>
          <input [validate]="phoneNumber.dirty || validateTriggered"
                 (countryChange)="onCountryChange($event)"
                 (intlTelInputObject)="telInputObject($event)"
                 (ng2TelOutput)="getNumber($event)"
                 [ng2TelInputOptions]="helpers.defaultTelInputOptions"
                 class="form-control"
                 formControlName="number"
                 ng2TelInput>
        </div>
      </div>

      <h4>{{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.LABEL' | translate }}</h4>
      <div class="form-row">
        <div class="form-group-sm col-md-4">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.COUNTRY.LABEL' | translate }}</label>
          <select
            [validate]="service.form.get('countryCode').dirty || validateTriggered"
            class="form-control"
            formControlName="countryCode"
          >
            <option value="">{{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.COUNTRY.OPTIONS.EMPTY' | translate }}</option>
            <option *ngFor="let c of (countries | pairs)" [value]="c[0]">{{ c[1] }}
            </option>
          </select>
        </div>

        <div class="form-group-sm col-md-4">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.CITY.LABEL' | translate }}</label>
          <input [validate]="service.form.get('cityName').dirty || validateTriggered"
                 type="text"
                 formControlName="cityName"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.ADDRESS.CITY.PLACEHOLDER' | translate"/>
        </div>

        <div class="form-group-sm col-md-4">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.POSTAL_CODE.LABEL' | translate }}</label>
          <input [validate]="service.form.get('postalCode').dirty || validateTriggered"
                 type="text"
                 formControlName="postalCode"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.ADDRESS.POSTAL_CODE.PLACEHOLDER' | translate"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="state-label"
                 placement="right"
                 [ngbTooltip]="'PAYMENT_FORM_MODAL.FORM.ADDRESS.STATE.TOOLTIP' | translate">
            {{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.STATE.LABEL' | translate }}
          </label>
          <input [validate]="service.form.get('stateProv').dirty || validateTriggered"
                 type="text"
                 formControlName="stateProv"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.ADDRESS.STATE.PLACEHOLDER' | translate"/>
        </div>
        <div class="form-group col-md-6">
          <label>{{ 'PAYMENT_FORM_MODAL.FORM.ADDRESS.STREET.LABEL' | translate }}</label>
          <input [validate]="service.form.get('street1').dirty || validateTriggered"
                 type="text"
                 formControlName="street1"
                 class="form-control"
                 [placeholder]="'PAYMENT_FORM_MODAL.FORM.ADDRESS.STREET.PLACEHOLDER' | translate"/>
        </div>
      </div>

      <div class="form-row content-center">
        <div><small><span class="text-primary"><b>*</b></span> {{ 'PAYMENT_FORM_MODAL.REQUIRED_FIELDS' | translate }}</small></div>
      </div>

      <ng-template #expirationDateControls>
        <label>
          {{ 'PAYMENT_FORM_MODAL.FORM.CARD.EXPIRATION_DATE.LABEL' | translate }}
          <span class="text-primary"><b>*</b></span>
        </label>
        <div class="form-row">
          <div class="col">
            <select [validate]="service.form.get('expiration_month').dirty || validateTriggered"
                    formControlName="expiration_month"
                    class="form-control">
              <option hidden selected value="">{{ 'PAYMENT_FORM_MODAL.FORM.CARD.EXPIRATION_DATE.MONTH.OPTIONS.EMPTY' | translate }}</option>
              <option *ngFor="let month of monthsList"
                      [disabled]="service.form.get('expiration_year').value === currentYear.toString() && (month | number) < currentMonth"
                      [value]="month">
                {{month }}
            </select>
          </div>
          <div class="col">
            <select [validate]="service.form.get('expiration_year').dirty || validateTriggered"
                    formControlName="expiration_year"
                    class="form-control"
                    (change)="onYearSelect($event.target.value)">
              <option hidden selected value="">{{ 'PAYMENT_FORM_MODAL.FORM.CARD.EXPIRATION_DATE.YEAR.OPTIONS.EMPTY' | translate }}</option>
              <option *ngFor="let year of yearsList" [value]="year">{{year}}
            </select>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-template>
